import { render, staticRenderFns } from "./modelBaseData.vue?vue&type=template&id=572836f1"
import script from "./modelBaseData.vue?vue&type=script&lang=js"
export * from "./modelBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports